/* Evolución — interacciones del tema. Vanilla JS, sin dependencias. */
(() => {
  'use strict';

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const theme = window.theme || { routes: {}, strings: {} };
  const routes = theme.routes;

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const fmt = format || theme.moneyFormat || '${{amount_no_decimals}}';
    const placeholder = /\{\{\s*(\w+)\s*\}\}/;
    const withDelims = (n, precision, thousands = ',', decimal = '.') => {
      if (isNaN(n) || n == null) return '0';
      n = (n / 100).toFixed(precision);
      const parts = n.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    };
    const match = fmt.match(placeholder);
    if (!match) return fmt;
    let value = '';
    switch (match[1]) {
      case 'amount': value = withDelims(cents, 2); break;
      case 'amount_no_decimals': value = withDelims(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelims(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelims(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelims(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = withDelims(cents, 0, ' '); break;
      case 'amount_with_space_separator': value = withDelims(cents, 2, ' ', ','); break;
      default: value = withDelims(cents, 0);
    }
    return fmt.replace(placeholder, value);
  }
  theme.formatMoney = formatMoney;

  /* ---------- Drawers & overlay ---------- */
  const overlay = $('[data-overlay]');
  let openDrawer = null;
  let lastTrigger = null;

  const focusables = (el) =>
    $$('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])', el)
      .filter((n) => n.offsetParent !== null);

  function showDrawer(drawer, trigger) {
    if (!drawer) return;
    if (openDrawer && openDrawer !== drawer) hideDrawer(false);
    lastTrigger = trigger || document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(() => {
      drawer.classList.add('is-open');
      if (overlay) { overlay.hidden = false; requestAnimationFrame(() => overlay.classList.add('is-visible')); }
    });
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    openDrawer = drawer;
    const autofocus = $('[data-autofocus]', drawer) || focusables(drawer)[0];
    setTimeout(() => autofocus && autofocus.focus({ preventScroll: true }), 60);
    $$('[aria-controls="' + drawer.id + '"]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
  }

  function hideDrawer(restoreFocus = true) {
    if (!openDrawer) return;
    const drawer = openDrawer;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    $$('[aria-controls="' + drawer.id + '"]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    if (overlay) {
      overlay.classList.remove('is-visible');
      setTimeout(() => { if (!openDrawer) overlay.hidden = true; }, 260);
    }
    document.body.classList.remove('is-locked');
    openDrawer = null;
    if (restoreFocus && lastTrigger && lastTrigger.focus) lastTrigger.focus({ preventScroll: true });
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      const target = document.getElementById(opener.getAttribute('data-drawer-open'));
      if (target) { e.preventDefault(); showDrawer(target, opener); }
      return;
    }
    if (e.target.closest('[data-drawer-close]') || e.target === overlay) {
      e.preventDefault();
      hideDrawer();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (!openDrawer) return;
    if (e.key === 'Escape') { hideDrawer(); return; }
    if (e.key === 'Tab') {
      const nodes = focusables(openDrawer);
      if (!nodes.length) return;
      const first = nodes[0];
      const last = nodes[nodes.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- Announcement rotation ---------- */
  $$('[data-announcement]').forEach((bar) => {
    const items = $$('.announcement__item', bar);
    if (items.length < 2) { items[0] && items[0].classList.add('is-active'); return; }
    let i = 0;
    items[0].classList.add('is-active');
    const speed = parseInt(bar.dataset.speed || '5', 10) * 1000;
    const inline = bar.classList.contains('announcement--inline') && window.matchMedia('(min-width: 990px)').matches;
    if (inline || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let timer = setInterval(next, speed);
    function next() { items[i].classList.remove('is-active'); i = (i + 1) % items.length; items[i].classList.add('is-active'); }
    bar.addEventListener('mouseenter', () => clearInterval(timer));
    bar.addEventListener('mouseleave', () => { timer = setInterval(next, speed); });
  });

  /* ---------- Header ---------- */
  const header = $('[data-header]');
  if (header) {
    const setOffset = () => {
      const h = header.getBoundingClientRect().height;
      document.documentElement.style.setProperty('--header-offset', Math.round(h) + 'px');
    };
    setOffset();
    window.addEventListener('resize', setOffset, { passive: true });
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Predictive search ----------
     Escritorio: el buscador del encabezado muestra resultados en un panel bajo el campo.
     Móvil: el ícono abre la barra superior (drawer) con el mismo comportamiento. */
  $$('[data-predictive-form]').forEach((form) => {
    const scope = form.closest('[data-search-scope]') || document;
    const input = $('input[name="q"]', form);
    const results = $('[data-predictive-results]', scope);
    const suggest = $('[data-search-suggest]', scope);
    const pop = scope.hasAttribute && scope.hasAttribute('data-search-inline') ? $('.search-pop', scope) : null;
    if (!input || !results) return;
    let controller;
    let timer;

    const hasContent = () => results.innerHTML.trim() !== '' || (suggest && !suggest.hidden);
    function openPop() {
      if (!pop || !hasContent()) return;
      pop.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }
    function closePop() {
      if (!pop) return;
      pop.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    }

    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) {
        results.innerHTML = '';
        if (suggest) suggest.hidden = false;
        if (pop && !suggest) closePop(); else openPop();
        return;
      }
      timer = setTimeout(() => run(q), 220);
    });
    input.addEventListener('focus', openPop);
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && pop && !pop.hidden) { e.stopPropagation(); closePop(); }
      if (e.key === 'ArrowDown') {
        const first = $('a', results) || (suggest && $('a', suggest));
        if (first) { e.preventDefault(); openPop(); first.focus(); }
      }
    });
    if (pop) {
      document.addEventListener('click', (e) => { if (!scope.contains(e.target)) closePop(); });
      scope.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') { closePop(); input.focus(); }
        if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') && e.target !== input) {
          const links = $$('a', pop);
          const i = links.indexOf(document.activeElement);
          if (i > -1) {
            e.preventDefault();
            const nextI = e.key === 'ArrowDown' ? Math.min(links.length - 1, i + 1) : i - 1;
            if (nextI < 0) input.focus(); else links[nextI].focus();
          }
        }
      });
      scope.addEventListener('focusout', () => {
        setTimeout(() => { if (!scope.contains(document.activeElement)) closePop(); }, 0);
      });
    }

    async function run(q) {
      if (controller) controller.abort();
      controller = new AbortController();
      try {
        const url = `${routes.predictiveSearch}?q=${encodeURIComponent(q)}&resources[type]=product,collection,page&resources[limit]=6&resources[options][unavailable_products]=last&section_id=predictive-search`;
        const res = await fetch(url, { signal: controller.signal });
        if (!res.ok) throw new Error(res.status);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const content = $('[data-predictive-content]', doc);
        results.innerHTML = content ? content.innerHTML : '';
        if (suggest) suggest.hidden = true;
        if (document.activeElement === input) openPop();
      } catch (err) {
        if (err.name !== 'AbortError') results.innerHTML = '';
      }
    }
  });

  /* ---------- Cart ---------- */
  const cartDrawer = $('#CartDrawer');

  function sectionsToRender() {
    const ids = [];
    if (cartDrawer) ids.push('cart-drawer');
    const main = $('[data-main-cart]');
    if (main && main.dataset.sectionId) ids.push(main.dataset.sectionId);
    return ids;
  }

  function renderSections(sections) {
    if (!sections) return;
    if (sections['cart-drawer'] && cartDrawer) {
      const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      const fresh = $('[data-cart-drawer-inner]', doc);
      const current = $('[data-cart-drawer-inner]', cartDrawer);
      if (fresh && current) current.replaceWith(fresh);
      const count = $('[data-cart-drawer-inner]', cartDrawer)?.dataset.count;
      if (count != null) updateCount(count);
      loadUpsell();
    }
    const main = $('[data-main-cart]');
    if (main && sections[main.dataset.sectionId]) {
      const doc = new DOMParser().parseFromString(sections[main.dataset.sectionId], 'text/html');
      const fresh = $('[data-main-cart]', doc);
      if (fresh) main.replaceWith(fresh);
      const count = fresh && fresh.dataset.count;
      if (count != null) updateCount(count);
    }
  }

  function updateCount(count) {
    $$('[data-cart-count]').forEach((el) => { el.textContent = Number(count) > 0 ? count : ''; });
    $$('[data-cart-link]').forEach((el) => el.setAttribute('aria-label', `Carrito, ${count} productos`));
  }

  async function addToCart(form, button) {
    const body = new FormData(form);
    const ids = sectionsToRender();
    if (ids.length) { body.append('sections', ids.join(',')); body.append('sections_url', window.location.pathname); }
    button && button.classList.add('is-loading');
    button && button.setAttribute('aria-busy', 'true');
    const error = $('[data-form-error]', form.closest('[data-product]') || form);
    if (error) error.hidden = true;
    try {
      const res = await fetch(`${routes.cartAdd}.js`, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || theme.strings.error);
      if (theme.cartType === 'page' || !cartDrawer) { window.location.href = routes.cart; return; }
      renderSections(data.sections);
      if (button && button.classList.contains('vcard__add')) {
        button.classList.add('is-done');
        setTimeout(() => button.classList.remove('is-done'), 1600);
      }
      showDrawer(cartDrawer, button);
      document.dispatchEvent(new CustomEvent('cart:added', { detail: data }));
    } catch (err) {
      if (error) { error.textContent = err.message || theme.strings.error; error.hidden = false; }
      else alert(err.message || theme.strings.error);
    } finally {
      button && button.classList.remove('is-loading');
      button && button.removeAttribute('aria-busy');
    }
  }

  async function changeLine(line, quantity) {
    const target = cartDrawer && cartDrawer.classList.contains('is-open') ? cartDrawer : $('[data-main-cart]');
    target && target.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(`${routes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: sectionsToRender(), sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || theme.strings.error);
      renderSections(data.sections);
    } catch (err) {
      window.location.reload();
    } finally {
      target && target.removeAttribute('aria-busy');
    }
  }

  // Product forms (ficha) and quick add forms (tarjetas)
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    const submitter = e.submitter;
    // "Comprar ahora" sends return_to=/checkout natively: let the browser handle it.
    if (submitter && submitter.name === 'return_to') return;
    if (form.hasAttribute('data-no-ajax')) return;
    if (theme.cartType === 'page' && !form.hasAttribute('data-quick-add')) return;
    e.preventDefault();
    addToCart(form, submitter || $('[type="submit"]', form));
  });

  // Quantity and remove inside cart
  document.addEventListener('click', (e) => {
    const qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      const wrap = qtyBtn.closest('[data-line]');
      if (wrap) {
        e.preventDefault();
        const current = parseInt(wrap.dataset.quantity, 10);
        const next = Math.max(0, current + parseInt(qtyBtn.dataset.qtyChange, 10));
        changeLine(parseInt(wrap.dataset.line, 10), next);
        return;
      }
      const input = $('input', qtyBtn.closest('.qty'));
      if (input) {
        e.preventDefault();
        const min = parseInt(input.min || '1', 10);
        input.value = Math.max(min, (parseInt(input.value, 10) || 1) + parseInt(qtyBtn.dataset.qtyChange, 10));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    const remove = e.target.closest('[data-line-remove]');
    if (remove) {
      e.preventDefault();
      changeLine(parseInt(remove.closest('[data-line]').dataset.line, 10), 0);
    }
  });

  // Cart note (debounced)
  let noteTimer;
  document.addEventListener('input', (e) => {
    if (!e.target.matches('[data-cart-note]')) return;
    clearTimeout(noteTimer);
    const note = e.target.value;
    noteTimer = setTimeout(() => {
      fetch(`${routes.cartUpdate}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note }) });
    }, 500);
  });

  // Upsell inside the cart drawer
  async function loadUpsell() {
    if (!cartDrawer) return;
    const slot = $('[data-upsell]', cartDrawer);
    if (!slot || !slot.dataset.productId) return;
    try {
      const res = await fetch(`${routes.recommendations}?product_id=${slot.dataset.productId}&limit=4&section_id=cart-upsell`);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const content = $('[data-upsell-content]', doc);
      if (content && content.innerHTML.trim()) { slot.innerHTML = content.innerHTML; slot.hidden = false; }
    } catch (err) { /* sin recomendaciones */ }
  }
  if (cartDrawer) loadUpsell();

  /* ---------- Product page ---------- */
  $$('[data-product]').forEach(initProduct);

  function initProduct(root) {
    const jsonEl = $('[data-product-json]', root);
    if (!jsonEl) return;
    const product = JSON.parse(jsonEl.textContent);
    const form = $('form[data-product-form]', root);
    const idInput = form && $('input[name="id"]', form);
    const pickers = $$('[data-option-index]', root);
    const sticky = $('[data-sticky-buy]');

    function selectedOptions() {
      const groups = {};
      pickers.forEach((input) => {
        if ((input.type === 'radio' && input.checked) || input.tagName === 'SELECT') groups[input.dataset.optionIndex] = input.value;
      });
      return Object.keys(groups).sort().map((k) => groups[k]);
    }

    function findVariant(options) {
      return product.variants.find((v) => v.options.every((o, i) => o === options[i]));
    }

    function render(variant) {
      const priceEls = $$('[data-price]', document);
      priceEls.forEach((el) => {
        const cur = $('[data-price-current]', el);
        const cmp = $('[data-price-compare]', el);
        const save = $('[data-price-save]', el);
        if (!variant) { if (cur) cur.textContent = theme.strings.unavailable; return; }
        if (cur) cur.textContent = formatMoney(variant.price);
        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (cmp) { cmp.hidden = !onSale; if (onSale) cmp.textContent = formatMoney(variant.compare_at_price); }
        if (save) {
          save.hidden = !onSale;
          if (onSale) {
            const diff = variant.compare_at_price - variant.price;
            const pct = Math.round((diff * 100) / variant.compare_at_price);
            save.textContent = `${theme.strings.save} ${formatMoney(diff)} (-${pct}%)`;
          }
        }
      });
      const badge = $('[data-gallery-badge]', root);
      if (badge && variant) {
        const onSale = variant.compare_at_price > variant.price;
        badge.hidden = !onSale;
        if (onSale) badge.textContent = `-${Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price)}%`;
      }
      const buttons = $$('[data-buy-button]', document);
      buttons.forEach((b) => {
        const available = variant && variant.available;
        b.disabled = !available;
        const label = $('[data-label]', b);
        if (label) label.textContent = available ? b.dataset.defaultLabel : (variant ? theme.strings.soldOut : theme.strings.unavailable);
      });
      if (variant && idInput) {
        idInput.value = variant.id;
        if (sticky) { const sid = $('input[name="id"]', sticky); if (sid) sid.value = variant.id; }
        try {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        } catch (err) { /* URL no editable (vista previa) */ }
        if (variant.featured_media) goToMedia(variant.featured_media.id);
      }
      $$('[data-variant-title]', document).forEach((el) => { el.textContent = variant ? variant.title : ''; });
    }

    pickers.forEach((input) => input.addEventListener('change', () => render(findVariant(selectedOptions()))));

    // Gallery
    const track = $('[data-gallery-track]', root);
    const dots = $$('[data-gallery-dot]', root);
    const thumbs = $$('[data-gallery-thumb]', root);
    function setActive(index) {
      dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
      thumbs.forEach((t, i) => { t.classList.toggle('is-active', i === index); t.setAttribute('aria-current', i === index ? 'true' : 'false'); });
    }
    function goTo(index) {
      if (!track) return;
      const slide = track.children[index];
      if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      setActive(index);
    }
    function goToMedia(mediaId) {
      if (!track) return;
      const idx = Array.from(track.children).findIndex((s) => s.dataset.mediaId === String(mediaId));
      if (idx > -1) goTo(idx);
    }
    if (track && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => { if (en.isIntersecting && en.intersectionRatio > 0.6) setActive(Array.from(track.children).indexOf(en.target)); });
      }, { root: track, threshold: [0.6] });
      Array.from(track.children).forEach((s) => io.observe(s));
    }
    dots.forEach((d, i) => d.addEventListener('click', () => goTo(i)));
    thumbs.forEach((t, i) => t.addEventListener('click', () => goTo(i)));

    // Optional extras (regalo, horario preferido): enable fields only when the box is checked
    $$('[data-extras]', root).forEach((box) => {
      const toggle = $('[data-extras-toggle]', box);
      const fields = $('[data-extras-fields]', box);
      const sync = () => {
        fields.hidden = !toggle.checked;
        $$('input, select, textarea', fields).forEach((f) => { f.disabled = !toggle.checked; });
      };
      toggle.addEventListener('change', sync);
      sync();
    });

    // Sticky buy bar
    const anchor = $('[data-buy-anchor]', root);
    if (sticky && anchor && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        document.body.classList.toggle('has-sticky-buy', show);
      });
      io.observe(anchor);
      // The sticky buttons submit the main form so line item properties travel too
      $$('[data-sticky-submit]', sticky).forEach((btn) => btn.addEventListener('click', (e) => {
        e.preventDefault();
        const mainBtn = $(btn.dataset.stickySubmit, form);
        if (mainBtn) form.requestSubmit ? form.requestSubmit(mainBtn) : mainBtn.click();
      }));
    }
  }

  /* ---------- Collection: filters and load more ---------- */
  const collection = $('[data-collection]');
  if (collection) {
    const sectionId = collection.dataset.sectionId;
    const facetForms = $$('[data-facets-form]');
    let timer;

    async function refresh(params, push = true) {
      const url = `${window.location.pathname}?${params}`;
      collection.setAttribute('aria-busy', 'true');
      try {
        const res = await fetch(`${url}${params ? '&' : ''}section_id=${sectionId}`);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        ['[data-collection-results]', '[data-facets-content]', '[data-active-filters]', '[data-results-count]'].forEach((sel) => {
          const fresh = $(sel, doc);
          $$(sel).forEach((el) => { if (fresh) el.innerHTML = fresh.innerHTML; });
        });
        if (push) window.history.pushState({ params }, '', url);
      } catch (err) {
        window.location.href = url;
      } finally {
        collection.removeAttribute('aria-busy');
      }
    }

    const paramsFrom = (form) => {
      const fd = new FormData(form);
      const params = new URLSearchParams();
      for (const [k, v] of fd.entries()) if (v !== '') params.append(k, v);
      return params.toString();
    };

    document.addEventListener('change', (e) => {
      const form = e.target.closest('[data-facets-form]');
      if (!form) return;
      // keep all facet forms (drawer + sort) in sync by merging
      clearTimeout(timer);
      timer = setTimeout(() => {
        const merged = new URLSearchParams();
        facetForms.forEach((f) => new URLSearchParams(paramsFrom(f)).forEach((v, k) => merged.append(k, v)));
        refresh(merged.toString());
      }, 300);
    });
    facetForms.forEach((f) => f.addEventListener('submit', (e) => { e.preventDefault(); refresh(paramsFrom(f)); hideDrawer(); }));

    document.addEventListener('click', (e) => {
      const remove = e.target.closest('[data-filter-remove]');
      if (remove) {
        e.preventDefault();
        const url = new URL(remove.href, window.location.origin);
        refresh(url.searchParams.toString());
      }
      const more = e.target.closest('[data-load-more]');
      if (more) {
        e.preventDefault();
        more.classList.add('is-loading');
        fetch(`${more.getAttribute('href')}&section_id=${sectionId}`)
          .then((r) => r.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const grid = $('[data-product-grid]');
            const items = $$('[data-product-grid] > *', doc);
            items.forEach((i) => grid.appendChild(i));
            const freshMore = $('[data-load-more-wrap]', doc);
            const wrap = $('[data-load-more-wrap]');
            if (wrap) wrap.innerHTML = freshMore ? freshMore.innerHTML : '';
          })
          .catch(() => { window.location.href = more.href; });
      }
    });

    window.addEventListener('popstate', (e) => refresh((e.state && e.state.params) || window.location.search.slice(1), false));
  }

  /* ---------- Carousel (reseñas) ---------- */
  $$('[data-carousel]').forEach((wrap) => {
    const track = $('[data-carousel-track]', wrap);
    if (!track || track.children.length < 2) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const autoplay = wrap.dataset.autoplay === 'true' && !reduce;
    const speed = Math.max(3, parseInt(wrap.dataset.speed || '5', 10)) * 1000;
    const scrollable = () => track.scrollWidth > track.clientWidth + 4;
    const step = () => {
      const items = track.children;
      return items[1] ? items[1].offsetLeft - items[0].offsetLeft : track.clientWidth;
    };
    function go(dir) {
      if (!scrollable()) return;
      const max = track.scrollWidth - track.clientWidth;
      let target = track.scrollLeft + dir * step();
      if (dir > 0 && track.scrollLeft >= max - 4) target = 0;
      if (dir < 0 && track.scrollLeft <= 4) target = max;
      track.scrollTo({ left: target, behavior: reduce ? 'auto' : 'smooth' });
    }
    let timer = null;
    let paused = false;
    let visible = true;
    const stop = () => { clearInterval(timer); timer = null; };
    const start = () => {
      stop();
      if (autoplay && !paused && visible && !document.hidden) timer = setInterval(() => go(1), speed);
    };
    const prev = $('[data-carousel-prev]', wrap);
    const next = $('[data-carousel-next]', wrap);
    if (prev) prev.addEventListener('click', () => { go(-1); start(); });
    if (next) next.addEventListener('click', () => { go(1); start(); });
    // Pausa mientras la persona interactúa con el carrusel
    wrap.addEventListener('mouseenter', () => { paused = true; stop(); });
    wrap.addEventListener('mouseleave', () => { paused = false; start(); });
    wrap.addEventListener('focusin', () => { paused = true; stop(); });
    wrap.addEventListener('focusout', () => { paused = false; start(); });
    track.addEventListener('touchstart', () => { paused = true; stop(); }, { passive: true });
    track.addEventListener('touchend', () => { paused = false; setTimeout(start, 2500); }, { passive: true });
    document.addEventListener('visibilitychange', start);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => { visible = en.isIntersecting; start(); }, { threshold: 0.25 }).observe(wrap);
    } else {
      start();
    }
  });

  /* ---------- Lead form tracking ---------- */
  $$('[data-lead-success]').forEach((el) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'generate_lead', form_name: el.dataset.leadSuccess });
    el.scrollIntoView({ block: 'center' });
  });

  /* ---------- Share ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-share]');
    if (!btn) return;
    e.preventDefault();
    const data = { title: document.title, url: btn.dataset.share };
    if (navigator.share) navigator.share(data).catch(() => {});
    else if (navigator.clipboard) navigator.clipboard.writeText(data.url).then(() => { btn.textContent = 'Enlace copiado'; });
  });
})();
